(() => {
  if (window.yrFigmaWishlistReady) return;
  window.yrFigmaWishlistReady = true;

  const selector = '.yr-fcard__wishlist-widget';
  const storageKey = 'yrFigmaWishlistProductIds';

  function readWishlistIds() {
    try {
      const value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return new Set(Array.isArray(value) ? value.map(String) : []);
    } catch (_error) {
      return new Set();
    }
  }

  function publishWishlistCount(ids = readWishlistIds()) {
    window.dispatchEvent(new CustomEvent('yr:wishlist-count', { detail: { count: ids.size } }));
  }

  function updateWishlistItem(widget, active) {
    const productId = widget.dataset.gwProductId;
    if (!productId || active === null) return;
    const ids = readWishlistIds();
    const alreadyActive = ids.has(String(productId));
    if (alreadyActive === active) return;
    if (active) ids.add(String(productId));
    else ids.delete(String(productId));
    try {
      window.localStorage.setItem(storageKey, JSON.stringify([...ids]));
    } catch (_error) {
      // The visual counter still updates when storage is unavailable.
    }
    publishWishlistCount(ids);
  }

  function getWidgetButton(widget) {
    return widget.querySelector('button') || widget.shadowRoot?.querySelector('button');
  }

  function readWidgetState(widget) {
    const button = getWidgetButton(widget);
    if (!button) return null;

    const ariaState = button.getAttribute('aria-pressed') || button.getAttribute('aria-checked');
    if (ariaState === 'true') return true;
    if (ariaState === 'false') return false;

    const stateText = `${button.className || ''} ${button.getAttribute('aria-label') || ''} ${button.title || ''}`.toLowerCase();
    if (/remove|gw-wl-active|is-active|wishlisted|удалить/.test(stateText)) return true;
    if (/add|добавить/.test(stateText)) return false;
    return null;
  }

  function syncWidget(widget) {
    const state = readWidgetState(widget);
    const shell = widget.closest('.yr-fcard__wishlist');
    if (state !== null && shell) shell.classList.toggle('is-wishlisted', state);
    updateWishlistItem(widget, state);
  }

  document.addEventListener('click', (event) => {
    const widget = event.target.closest?.(selector);
    if (!widget) return;

    const shell = widget.closest('.yr-fcard__wishlist');
    const currentState = readWidgetState(widget);
    const nextState = currentState === null ? !shell?.classList.contains('is-wishlisted') : !currentState;
    shell?.classList.toggle('is-wishlisted', nextState);
    updateWishlistItem(widget, nextState);
    window.setTimeout(() => syncWidget(widget), 500);
    window.setTimeout(() => syncWidget(widget), 1200);
  }, true);

  const observer = new MutationObserver(() => {
    document.querySelectorAll(selector).forEach(syncWidget);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.querySelectorAll(selector).forEach(syncWidget);
  publishWishlistCount();
})();
